/** The create → affect transform chain. */
import type { Shape } from './scene';
import type { AffectModule, CreateModule, ModuleContext } from './module-api';

export type CtxFor = (moduleId: string) => ModuleContext;

/**
 * Run one create module, then fold each affect over its output in order.
 * `commit` selects the affect's freeze hook (onCommit) over its live preview.
 * Order matters and is user-reorderable — Mirror→Repeat ≠ Repeat→Mirror.
 */
export function runPipeline(
  create: CreateModule,
  affects: readonly AffectModule[],
  ctxFor: CtxFor,
  commit: boolean,
): Shape[] {
  const cctx = ctxFor(create.manifest.id);
  if (!commit) create.onFrame?.(cctx);
  let shapes = create.getLiveShapes(cctx);
  for (const a of affects) {
    const actx = ctxFor(a.manifest.id);
    if (!commit) a.onFrame?.(actx);
    shapes = commit && a.onCommit ? a.onCommit(shapes, actx) : a.affect(shapes, actx);
  }
  return shapes;
}
